// extracted by mini-css-extract-plugin
module.exports = {"red":"Difference_style_red__1g34I","green":"Difference_style_green__2mc4Q"};